import { Component, OnInit,Input,EventEmitter,Output} from '@angular/core';
import{QuestionManagementService} from '../../../Services/question-management/question-management.service';
import { AnswerChoiceModel } from 'src/app/Models/AnswerChoiceModel';
import { QuestionStatusModel } from 'src/app/Models/QuestionStatusById';
import { FormBuilder, FormGroup } from '@angular/forms';
import { VAddAnswerChoice } from 'src/app/Validators/Validators';
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'app-questionstatus-history',
  templateUrl: './questionstatus-history.component.html',
  styleUrls: ['./questionstatus-history.component.css']
})
export class QuestionstatusHistoryComponent implements OnInit {
  @Input() subjectById:any;
  @Input() selectedQuestionById:any;
  @Output() ReturnQuestionStatushistory : EventEmitter<any> = new EventEmitter<any>();


  constructor(public service:QuestionManagementService,private fb: FormBuilder,private toastr: ToastrService) { }

  ngOnInit() {
    this.getBreadcrumbDetails();
    this.GetQuestionStatusChanges(this.selectedQuestionById.Question_ID);
  }

  Breadcrumblist:any;
 getBreadcrumbDetails() {
   this.service.getBreadcrumbDetails({ 'ID': this.subjectById.Subject_Id }).subscribe((i: any) => {
     this.Breadcrumblist = i;
    //  this.path =
  //  }).catch((e: any) => {
  //    this.subjectById = null;
  //  }
  //  )
}, error => {  console.log(error) }
);
 }

 QuestionStatusList:any;
 Question:any;
 GetQuestionStatusChanges(data:any){
   
   this.service.GetQuestionStatusHistory({'QuestionID':data}).subscribe((i:any)=>{
     this.Question=i;
     this.QuestionStatusList=this.Question.QuestionStatusHistory;
  //  }).catch((e:any)=>{
  //    this.QuestionStatusList=null;
  //  });
}, error => {  console.log(error) }
);
 }

 Modalpopup:any;
 CloseStatusPopup(){
   this.ReturnQuestionStatushistory.emit(this.Modalpopup);
 }
}

